import React, { useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  makeStyles,
  createTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TablePagination from "@material-ui/core/TablePagination";

import { THEME_COLOR } from "./../../config/config";

const useStyles = makeStyles((theme) => ({
  paginationRoot: {
    "@media (max-width: 600px)": {
      "& .MuiToolbar-root": {
        justifyContent: "flex-start",
        paddingLeft: "8px",
        minHeight: "52px",
      },
      "& .MuiTablePagination-spacer": {
        display: "none",
      },
      "& .MuiTablePagination-caption": {
        fontSize: "0.875rem",
      },
    },
  },
}));

const theme = createTheme({
  shadows: Array(5).fill("none"),
  overrides: {
    MUIDataTableHeadCell: {
      root: { zIndex: 0 },
      fixedHeader: { zIndex: 1 },
      data: { whiteSpace: "nowrap" },
    },
    MuiTableFooter: { root: { background: "#f0f2f4" } },
  },
  MuiFormLabel: { zIndex: 0 },
  MuiTableHead: { zIndex: 0 },
  palette: { primary: { main: THEME_COLOR } },
});

export default function DataTable(props) {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const tableData = Array.isArray(props.tableData) ? props.tableData : [];

  const options = {
    filter: true,
    selectableRows: "none",
    rowHover: true,
    responsive: "standard",
    tableBodyHeight : "100%",
    pagination: false,
  };

  const paginatedData = tableData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  return (
    <ThemeProvider theme={theme}>
      <div style={{ isolation: "isolate" }}>
        <MUIDataTable
          title={props.title}
          data={paginatedData}
          columns={props.columns}
          options={options}
        />

        <TablePagination
          component="div"
          count={tableData.length}
          page={page}
          onPageChange={(e, p) => setPage(p)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[25, 50, 100]}
          className={classes.paginationRoot}
        />
      </div>
    </ThemeProvider>
  );
}
